import React, { useState, useRef } from "react";
import Slider from "react-slick";
import useStyles, { FormInputSelect } from "./styles";
import Navbar2 from "../../components/Navbar2/Navbar2";
import Section from "../../components/Section/Section";
import Footer from "../../components/Footer/Footer";
import FormInputNoLabel from "../../components/FormInputNoLabel/FormInputNoLabel";
import Paragraph from "../../components/Typography/Paragraph";
import Card from "../../components/Card/Card";
import Loader from "react-js-loader";

import giftbox from "../../assets/images/giftbox.png";
import wallet from "../../assets/images/wallet.png";
import slot from "../../assets/images/slot.png";
import result from "../../assets/images/result.png";
import event from "../../assets/images/event.png";
import subscribe from "../../assets/images/subscribe.png";
import { useDropzone } from "react-dropzone";
import {
  Checkbox,
  Grid,
  Table,
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Collapse,
  MenuItem,
  Dialog,
  DialogTitle,
  DialogContent,
  TablePagination,
  Autocomplete,
  Box,
} from "@mui/material";
import Button from "../../components/Button/Button";
import {
  MoreVert,
  AddCircle,
  RemoveCircle,
  ArrowCircleDown,
  ArrowCircleUp,
  SubdirectoryArrowRight,
  GridView,
  List,
  Close,
  InsertDriveFile,
  InsertPhoto,
} from "@mui/icons-material";
import {
  get_inventory_by_customer,
  get_customer_contact,
  get_customer_cart,
  save_customer_cart,
  validate_cart_admin,
  get_color_name,
  get_inventory_by_customer_children,
  get_class,
  get_merchandiser,
  get_sales_rep,
  get_upload_file,
  get_shipping_method_admin,
  get_customer_detail,
  create_orders_admin,
} from "../../API/API";

import ShirtIcon from "../../assets/images/shirt.svg";

import "./styles.css";
import FormInput from "../../components/FormInput/FormInput";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import toast from "react-simple-toasts";
import useUser from "../../hooks/useUser";

export default function EditCart() {
  const classes = useStyles();
  const navigate = useNavigate();
  const params = useParams();
  const OrderProductRef = useRef(null);

  const { set_user, get_user } = useUser();

  const location = useLocation();

  const [page, setPage] = React.useState("order");
  const [pageNum, setPageNum] = React.useState(0);
  const [viewType, setViewType] = React.useState("grid");
  const [displayFloat, setDisplayFloat] = useState(false);
  const [loading, setLoading] = React.useState(false);
  const [loadingCart, setLoadingCart] = React.useState(false);
  const [loadingItem, setLoadingItem] = React.useState(false);
  const [loadingAdd, setLoadingAdd] = React.useState(false);
  const [searchKey, setSearchKey] = React.useState("");
  const [colorData, setColorData] = React.useState(null);
  const [colorSort, setColorSort] = React.useState("All");
  const [customer, setcustomer] = React.useState(null);
  const [selectedCustomer, setSelectedCustomer] = React.useState(null);
  const [allData, setAllData] = React.useState([]);
  const [totalList, setTotalList] = React.useState(1);
  const [inventory, setInventory] = React.useState(null);
  const [productList, setProductList] = React.useState([]);
  const [open, setOpen] = React.useState(false);
  const [selectedItem, setSelectedItem] = React.useState(null);
  const [selectedGrid, setSelectedGrid] = React.useState(null);
  const [billtype, setBilltype] = React.useState(null);
  const [orderFee, setOrderFee] = React.useState({
    final_amount: "0.00",
    handling_fee: "0.00",
    shipping_fee: "0.00",
    discountamount: "0.00",
    total_amount: "0.00",
    tax_fee: "0.00",
  });

  const getData = () => {
    setLoading(true);
    get_customer_contact({
      page: 1,
    }).then((json) => {
      setLoading(false);
      setcustomer(json.data);
    });
  };

  React.useEffect(() => {
    getData();
    getColor();
  }, []);

  const handleSearch = (event) => {
    setSearchKey(event.target.value);
    var _data = searchData(allData, event.target.value);
    setInventory(_data);
    setTotalList(_data.length);
  };

  const searchData = (data, searchKey) => {
    var _data = [];
    if (searchKey != "") {
      for (var i = 0; i < data.length; i++) {
        if (
          (data[i].itemname &&
            data[i].itemname.toUpperCase().indexOf(searchKey.toUpperCase()) >
              -1) ||
          (data[i].displayname &&
            data[i].displayname.toUpperCase().indexOf(searchKey.toUpperCase()) >
              -1)
        ) {
          _data.push(data[i]);
        } else if (data[i].children && data[i].children.length) {
          for (var j = 0; j < data[i].children.length; j++) {
            if (
              (data[i].children[j].hscode &&
                data[i].children[j].hscode
                  .toUpperCase()
                  .indexOf(searchKey.toUpperCase()) > -1) ||
              (data[i].children[j].itemname &&
                data[i].children[j].itemname
                  .toUpperCase()
                  .indexOf(searchKey.toUpperCase()) > -1) ||
              (data[i].children[j].displayname &&
                data[i].children[j].displayname
                  .toUpperCase()
                  .indexOf(searchKey.toUpperCase()) > -1)
            ) {
              _data.push(data[i]);
            }
          }
        }
      }
    } else {
      _data = [...data];
    }
    return _data;
  };

  const [customerID, setCustomerID] = useState(0);
  const getInventory = (e) => {
    setLoadingItem(true);
    setCustomerID(e);
    var temp_product = [];
    get_inventory_by_customer({
      customer_id: e,
      color: colorSort,
    }).then((json) => {
      setLoadingItem(false);
      temp_product = [...json.data];
      for (var i = 1; i < temp_product.length; i++) {
        temp_product[i]["openTable"] = false;
      }
      setAllData(temp_product);
      var _data = searchData(temp_product, searchKey);
      setInventory(_data);
      setTotalList(_data.length);
    });
  };
  React.useEffect(() => {
    if (selectedCustomer != null) {
      getInventory(selectedCustomer.customer_id);
    }
  }, [colorSort]);

  const getColor = () => {
    get_color_name({}).then((json) => {
      setColorData(json.data);
    });
  };

  const getCustomerCart = (e) => {
    setLoadingCart(true);
    get_customer_cart({ customer_contact_id: e }).then((json) => {
      if (json.status) {
        setLoadingCart(false);
        setProductList(json.data);

        validate_cart_admin({
          item: JSON.stringify(json.data),
          customer_contact_id: e,
        }).then((json) => {
          if (json.status) {
            // setProductList(json.data);
            setOrderFee({
              total_amount: json.total_amount,
              discountamount: json.discountamount,
              shipping_fee: json.shipping_fee,
              handling_fee: json.handling_fee,
              discountamount: json.discountamount,
              final_amount: json.final_amount,
              tax_fee: billtype == "SST" ? json.sst : json.gst,
            });
          } else {
          }
        });
      } else {
        toast(json.message);
      }
    });
  };

  const handleGoItem = () => {
    if (selectedCustomer === null) {
      toast("Please Choose a Customer");
      return;
    }
    setPage("product");
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const handleOpen = (e) => {
    setOpen(true);
    setSelectedItem({
      internalid: e.internalid,
      quantity: 1,
      description: "",
      hscode: e.hscode,
      itemname: e.itemname,
      color: e.colorname != "" ? e.colorname + " " + e.color : "",
      size: e.size != "" ? e.size : "",
      price: e.hasOwnProperty("price") ? e.price : "",
      type: e.type,
      quantityavailable: e.quantityavailable,
    });
  };

  const handleClose = (value) => {
    setOpen(false);
  };

  const handleChangeProduct = (e) => {
    setSelectedItem({
      ...selectedItem,
      [e.target.name]: e.target.value,
    });
  };

  const handleChangeProduct2 = (e) => {
    const newValue = e.target.value;
    const newQuantity = newValue < 1 ? 1 : newValue;

    setSelectedItem({
      ...selectedItem,
      [e.target.name]: newQuantity,
    });
  };

  const handleChangeGrid = (e, index, item) => {
    if (e.target.value == "") {
      toast("Please Insert Quantity");
      return;
    }
    if (e.target.value == 0) {
      toast("Quantity Cannot be 0");
      return;
    }

    let list = [...productList];

    var data = e.target.id;
    var datasplit = data.split("_");
    var internalid = datasplit[0];
    var hscode = datasplit[1];
    var itemname = datasplit[2];
    var price = datasplit[3];
    var type = datasplit[4];
    var color = datasplit[5];
    var quantityavailable = datasplit[6];
    var size = datasplit[7];

    var quantity = e.target.value !== "" ? parseInt(e.target.value) : 0;

    if (quantity > 0) {
      if (quantity > quantityavailable) {
        toast("Not Enough Quantity Available");
        return;
      }

      var data = {
        hscode: hscode,
        itemname: itemname,
        price: price,
        type: type,
        color: color,
        quantity: e.target.value,
        internalid: internalid,
        description: "",
        quantityavailable: quantityavailable,
        size: size,
      };

      var existed = 0;

      for (var i = 0; i < list.length; i++) {
        if (internalid == list[i].internalid) {
          existed = 1;
          list[i] = data;
        }
      }

      if (existed == 0 && data.quantity >= 1) {
        data["index"] = list.length;
        list.push(data);
      }
    } else {
      for (var i = 0; i < list.length; i++) {
        if (internalid == list[i].internalid) {
          list.splice(i, 1);
        }
      }
    }

    setProductList(list);
  };

  const addProduct = () => {
    if (
      selectedItem.type == "Matrix Item" &&
      parseFloat(selectedItem.quantity) >
        parseFloat(selectedItem.quantityavailable)
    ) {
      toast("Not Enough Quantity");
      return;
    }

    if (selectedItem.type != "Matrix Item" && selectedItem.price == 0) {
      toast("Please Insert Price");
      return;
    }

    var pro_temp = [...productList];
    if (pro_temp.length === 0) {
      selectedItem["index"] = 0;
      pro_temp.push(selectedItem);
    } else {
      var existed = 0;
      var index = 0;
      for (var i = 0; i < pro_temp.length; i++) {
        if (
          selectedItem.type == "Matrix Item" &&
          pro_temp[i].internalid === selectedItem.internalid
        ) {
          existed = 1;
          index = i;
          break;
        } else if (selectedItem.type != "Matrix Item") {
          existed = 0;
          index = i;
          break;
        }
      }

      if (existed == 1) {
        if (
          selectedItem.type == "Matrix Item" &&
          parseFloat(pro_temp[index].quantity) +
            parseFloat(selectedItem.quantity) >
            parseFloat(selectedItem.quantityavailable)
        ) {
          toast("Not Enough Quantity");
          return;
        }

        var new_quantity =
          parseFloat(pro_temp[index].quantity) +
          parseFloat(selectedItem.quantity);

        pro_temp[index]["quantity"] = new_quantity;
      } else {
        selectedItem["index"] = pro_temp.length;
        pro_temp.push(selectedItem);
      }
    }
    setProductList(pro_temp);

    toast("Product Added");
    handleClose();
  };

  const [openEditDesc, setOpenEditDesc] = React.useState(false);
  const [selectedIndexProduct, setSelectedIndexProduct] = React.useState(null);

  const handleChangeIndexProduct = (e) => {
    setSelectedIndexProduct({
      ...selectedIndexProduct,
      [e.target.name]: e.target.value,
    });
  };

  const handleOpenAddIndexProduct = (e) => {
    // console.log(e)
    setOpenEditDesc(true);
    setSelectedIndexProduct({
      ...e,
    });
  };

  const handleCloseIndexProduct = (e) => {
    var pro_temp = [...productList];
    pro_temp[selectedIndexProduct.index]["description"] =
      selectedIndexProduct.description;
    setProductList(pro_temp);
    setSelectedIndexProduct(null);
    setOpenEditDesc(false);
  };

  const handleChangeQty = (index, qty) => {
    var pro_temp = [...productList];

    var new_quantity = parseFloat(pro_temp[index].quantity) + parseFloat(qty);

    if (
      pro_temp[index].type == "Matrix Item" &&
      parseFloat(new_quantity) > parseFloat(pro_temp[index].quantityavailable)
    ) {
      toast("Not Enough Quantity");
      return;
    }

    pro_temp[index]["quantity"] = new_quantity;

    for (var i = 0; i < pro_temp.length; i++) {
      if (pro_temp[i].quantity < 1) {
        pro_temp.splice(i, 1);
      }
    }
    setProductList(pro_temp);

    if (selectedCustomer !== null) {
      var data = {
        item: JSON.stringify(pro_temp),

        customer_contact_id: selectedCustomer.customer_contact_id,
      };

      validate_cart_admin(data).then((json) => {
        if (json.status) {
          setProductList(json.data);
          setOrderFee({
            total_amount: json.total_amount,
            discountamount: json.discountamount,
            shipping_fee: json.shipping_fee,
            handling_fee: json.handling_fee,
            discountamount: json.discountamount,
            final_amount: json.final_amount,
            tax_fee: billtype == "SST" ? json.sst : json.gst,
          });
        } else {
        }
      });
    }
  };

  const handleChangeQtyText = (index, e) => {
    var pro_temp = [...productList];
    var new_quantity = parseFloat(e.target.value);

    // Check if the new quantity is a valid number
    if (isNaN(new_quantity)) {
      // If it's not a number, set the new quantity to the previous value
      new_quantity = pro_temp[index]["quantity"];
    } else if (
      pro_temp[index].type == "Matrix Item" &&
      parseFloat(new_quantity) > parseFloat(pro_temp[index].quantityavailable)
    ) {
      toast("Not Enough Quantity");
      return;
    }

    pro_temp[index]["quantity"] = new_quantity;
    setProductList(pro_temp);
  };

  const handleChangeDiscountText = (index, e) => {
    var pro_temp = [...productList];
    var new_discount = parseFloat(e.target.value);

    if (isNaN(new_discount)) {
      new_discount = 0;
    }
    pro_temp[index]["given_discount"] = new_discount;
    setProductList(pro_temp);
    calculateCart();
  };

  const handleChangePage = (e, ispage) => {
    setPageNum(ispage);
    // setOpen(false);
  };

  // const handleChangeTable = (item, index) => {
  //   console.log("IM HERE", item);

  //   var temp_data = [...inventory];
  //   temp_data[index]["openTable"] = !temp_data[index]["openTable"];
  //   console.log("IM HERE 2", temp_data[index]);
  //   setInventory(temp_data);
  // };

  // const handleChangeTable = (item) => {
  //   setOpen((prev) => ({
  //     ...prev,
  //     [item.item_id]: !prev[item.item_id]
  //   }));
  // };

  const handleChangeTable = async (item) => {
    if (!open[item.item_id]) {
      var res = await get_inventory_by_customer_children({
        internalid: item.internalid,
        customer_id: customerID,
      });
      if (res.status) {
        var _product = [...allData];
        item.children = res.data.children;
        item.children_grid = res.data.children_grid;

        setAllData(_product);
        var _data = searchData(_product, searchKey);
        setInventory(_data);
      }
    }

    setOpen((prev) => {
      const newState = { ...prev };
      Object.keys(newState).forEach((key) => {
        if (key !== item.item_id) {
          newState[key] = false;
        }
      });
      newState[item.item_id] = !prev[item.item_id];
      return newState;
    });
  };

  var is_changing_shipping_fee = useRef(null);
  var is_calculating = false;

  const calculateCart = () => {
    if (selectedCustomer !== null) {
      var data = {
        item: JSON.stringify(productList),

        customer_contact_id: selectedCustomer.customer_contact_id,
      };

      validate_cart_admin(data).then((json) => {
        if (json.status) {
          setProductList(json.data);
          // setProductListNew(json.data)
          setOrderFee({
            total_amount: json.total_amount,
            discountamount: json.discountamount,
            shipping_fee: json.shipping_fee,
            handling_fee: json.handling_fee,
            discountamount: json.discountamount,
            final_amount: json.final_amount,
            tax_fee: billtype == "SST" ? json.sst : json.gst,
          });
        } else {
        }
      });
    }
  };

  const handleRemoveItem = (i) => {
    var temp_data = [...productList];
    temp_data.splice(i, 1);
    setProductList(temp_data);
  };

  React.useEffect(() => {
    calculateCart();
  }, []);

  React.useEffect(() => {}, [orderFee]);

  const handleSubmitOrder = () => {
    if (selectedCustomer === null) {
      toast("Please Choose a Customer");
      return;
    }
    if (productList.length === 0) {
      toast("Please Add Item");
      return;
    }
    var data = {
      customer_contact_id: selectedCustomer.customer_contact_id,
      cart_data: JSON.stringify(productList),
    };
    save_customer_cart(data).then((json) => {
      setLoadingAdd(true);
      if (json.status) {
        setLoadingAdd(false);
        toast("Customer Cart Updated");
        getCustomerCart(selectedCustomer.customer_contact_id);
      } else {
        setLoadingAdd(false);
        toast(json.message);
      }
    });
  };

  // DIRECT CHECKOUT

  const [openDirectCheckout, setOpenDirectCheckout] = React.useState(false);

  const handleOpenDirectCheckout = () => {
    if (selectedCustomer === null) {
      toast("Please Choose a Customer");
      return;
    }
    if (productList.length === 0) {
      toast("Please Add Item");
      return;
    }
    setOpenDirectCheckout(true);
  };

  const [customerAddress, setCustomerAddress] = React.useState([]);
  const [selectedShippingCustomerAddress, setSelectedShippingCustomerAddress] =
    React.useState(null);
  const [selectedBillingCustomerAddress, setSelectedBillingCustomerAddress] =
    React.useState(null);
  const [loadingAddress, setLoadingAddress] = React.useState(false);
  const [classList, setClassList] = React.useState(null);
  const [selectedClass, setSelectedClass] = React.useState("");
  const [merchandiser, setMerchandiser] = React.useState(null);
  const [selectedMerchandiser, setSelectedMerchandiser] = React.useState(0);
  const [rep, setRep] = React.useState(null);
  const [selectedRep, setSelectedRep] = React.useState(0);
  const [shippingMethod, setShippingMethod] = React.useState([]);
  const [shippingCarrier, setShippingCarrier] = React.useState([]);
  const [selectedShippingMethod, setSelectedShippingMethod] = React.useState({
    shipping_method_id: 0,
    shipping_carrier_id: 0,
  });
  const [deposit, setDeposit] = React.useState("0.00");
  const [remark, setRemark] = React.useState({
    sales_remark: "",
    customer_remark: "",
    memo: "",
    bypasscl: false,
  });
  const [selectedCustomerAdditionalInfo, setSeelctedCustomerAdditionalInfo] =
    React.useState({
      balance: 0,
      depositBalance: 0,
    });
  const [customerPO, setCustomerPO] = React.useState("");
  const [attachment, setAttachment] = React.useState("");

  const getAllData = () => {
    get_class({}).then((json) => {
      setClassList(json.data);
      setSelectedClass(json.data[0].class);
    });
    get_merchandiser({}).then((json) => {
      setMerchandiser(json.data);
    });
    get_sales_rep({}).then((json) => {
      setRep(json.data);
    });
  };

  React.useEffect(() => {
    getAllData();
  }, []);

  const handleGetShippingMethod = (e) => {
    if (e !== "") {
      get_shipping_method_admin({
        customer_contact_id: e,
      }).then((json) => {
        setShippingMethod(json.data);
        setShippingCarrier([]);
        setSelectedShippingMethod({
          shipping_carrier_id: 0,
          shipping_method_id: 0,
        });
      });
    } else {
      setShippingMethod([]);
      setShippingCarrier([]);
      setSelectedShippingMethod({
        shipping_carrier_id: 0,
        shipping_method_id: 0,
      });
    }
  };

  const handleGetCustomerData = (e) => {
    // console.log('e,e', e)
    if (e !== "") {
      setLoadingAddress(true);
      get_customer_detail({
        customer_id: e,
        // sort: sort
      }).then((json) => {
        setLoadingAddress(false);
        setCustomerAddress(json.data.address);
        setSelectedBillingCustomerAddress({
          ...selectedBillingCustomerAddress,
          customer_address_id: json.data.default_billing_address_id,
          addr1: json.data.billing_addr1,
          addr2: json.data.billing_addr2,
          city: json.data.billing_city,
          zip: json.data.billing_zip,
          state: json.data.billing_state,
          country: json.data.billing_country,
        });
        setSeelctedCustomerAdditionalInfo({
          balance: json.data.balance,
          depositBalance: json.data.depositBalance,
        });
        setSelectedShippingCustomerAddress(null);
        setSelectedRep(json.data.salesrep);
        // console.log(json.data.subsidiary, json.data.subsidiary == 2)
        if (json.data.subsidiary == 2) {
          setBilltype("SST");
        } else {
          setBilltype("GST");
        }
      });
    } else {
      setCustomerAddress([]);
      setSelectedBillingCustomerAddress(null);
      setSelectedShippingCustomerAddress(null);
    }
  };

  const handleChangeRemark = (e) => {
    setRemark({
      ...remark,
      [e.target.name]: e.target.value,
    });
  };

  const handleChangeShippingMethod = (e) => {
    setSelectedShippingMethod({
      ...selectedShippingMethod,
      shipping_method_id: e.shipping_method_id,
      shipping_carrier_id: 0,
    });
    setShippingCarrier(e.carrier);
  };

  const handleChangeShippingCarrier = (e) => {
    setSelectedShippingMethod({
      ...selectedShippingMethod,
      shipping_carrier_id: e.shipping_carrier_id,
    });
  };

  const [uploadPDF, setUploadPDF] = React.useState("");
  //DropZone

  const dropzone = {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: "20px",
    borderWidth: "2px",
    borderRadius: "2px",
    borderColor: "#eeeeee",
    borderStyle: "dashed",
    backgroundColor: "#fafafa",
    color: "#bdbdbd",
    outline: "none",
    marginBottom: ".6rem",
  };

  const thumbsContainer = {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    marginTop: 16,
  };

  const thumb = {
    display: "inline-flex",
    borderRadius: 2,
    border: "1px solid #eaeaea",
    marginBottom: 8,
    marginRight: 8,
    // width: 100,
    height: 100,
    padding: 4,
    boxSizing: "border-box",
  };

  const thumbInner = {
    display: "flex",
    minWidth: 0,
    overflow: "hidden",
  };

  const img = {
    display: "block",
    width: "auto",
    height: "100%",
  };

  const [files, setFiles] = React.useState([]);
  const [files2, setFiles2] = React.useState([]);
  const [files3, setFiles3] = React.useState([]);
  const { getRootProps, getInputProps, fileRejections } = useDropzone({
    // accept: "image/jpeg, image/png",
    maxFiles: 1,
    onDrop: async (acceptedFiles) => {
      console.log(acceptedFiles);
      if (acceptedFiles.length === 1) {
        const file = acceptedFiles[0];
        // const file = Array.from(acceptedFiles);

        var index = 0;

        var formData = new FormData();

        // for (let i = 0; i < file.length; i++) {
        //   formData.append("image[]", file[i]);
        //   index = i;
        // }

        formData.append("image", file);

        if (productList.length === 0) {
          toast("Please add item");
          return;
        } else {
          var res = await get_upload_file(formData);
          if (res.data.status) {
            // setUploadAttachment({
            //   ...uploadAttachment,
            //   attachment: res.data.data,
            // });
            setUploadPDF({
              file: res.data.data,
            });
            calculateCart();
          } else {
            // alert(res.data.message);
          }
        }
      } else {
        toast("Please Upload One Consignment Note Only");
      }
      setFiles(
        acceptedFiles.map((file) =>
          Object.assign(file, {
            preview: URL.createObjectURL(file),
          })
        )
      );
    },
  });

  const attachmentDropzone = useDropzone({
    maxFiles: 1,
    onDrop: async (acceptedFiles) => {
      console.log(acceptedFiles);
      if (acceptedFiles.length === 1) {
        const file = acceptedFiles[0];
        var index = 0;
        var formData = new FormData();
        formData.append("image", file);

        var res = await get_upload_file(formData);
        if (res.data.status) {
          setAttachment(res.data.data);
        } else {
        }
      } else {
        toast("Please Upload One File Only");
      }
      setFiles2(
        acceptedFiles.map((file) =>
          Object.assign(file, {
            preview: URL.createObjectURL(file),
          })
        )
      );
    },
  });

  const customerpoDropzone = useDropzone({
    maxFiles: 1,
    onDrop: async (acceptedFiles) => {
      console.log(acceptedFiles);
      if (acceptedFiles.length === 1) {
        const file = acceptedFiles[0];
        var index = 0;
        var formData = new FormData();
        formData.append("image", file);

        var res = await get_upload_file(formData);
        if (res.data.status) {
          setCustomerPO(res.data.data);
        } else {
        }
      } else {
        toast("Please Upload One File Only");
      }
      setFiles3(
        acceptedFiles.map((file) =>
          Object.assign(file, {
            preview: URL.createObjectURL(file),
          })
        )
      );
    },
  });

  const thumbs = files.map((file, index) => (
    <div
      style={{
        background: "#eaeaea",
        borderRadius: "4px",
        padding: "1rem",
        marginBottom: "1rem",
        display: "flex",
        justifyContent: "space-between",
      }}
    >
      <div key={file.name} style={{ display: "flex", alignItems: "center" }}>
        {file.type == "application/pdf" && (
          <InsertDriveFile sx={{ marginRight: "12px", color: "#F90000" }} />
        )}
        {file.type == "image/png" && (
          <InsertPhoto sx={{ marginRight: "12px", color: "#00b5a2" }} />
        )}

        {file.type == "image/jpeg" && (
          <InsertPhoto sx={{ marginRight: "12px", color: "#00b5a2" }} />
        )}

        <p style={{ margin: 0 }}>{file.name}</p>
      </div>
      <Close
        sx={{ color: "#F90000", zIndex: 1 }}
        onClick={() => handleDelete(index)}
      />
    </div>
  ));

  const thumbs2 = files2.map((file, index) => (
    <div
      style={{
        background: "#eaeaea",
        borderRadius: "4px",
        padding: "1rem",
        marginBottom: "1rem",
        display: "flex",
        justifyContent: "space-between",
      }}
    >
      <div key={file.name} style={{ display: "flex", alignItems: "center" }}>
        {file.type == "application/pdf" && (
          <InsertDriveFile sx={{ marginRight: "12px", color: "#F90000" }} />
        )}
        {file.type == "image/png" && (
          <InsertPhoto sx={{ marginRight: "12px", color: "#00b5a2" }} />
        )}

        {file.type == "image/jpeg" && (
          <InsertPhoto sx={{ marginRight: "12px", color: "#00b5a2" }} />
        )}

        <p style={{ margin: 0 }}>{file.name}</p>
      </div>
      <Close
        sx={{ color: "#F90000", zIndex: 1 }}
        onClick={() => handleDelete2(index)}
      />
    </div>
  ));

  const thumbs3 = files3.map((file, index) => (
    <div
      style={{
        background: "#eaeaea",
        borderRadius: "4px",
        padding: "1rem",
        marginBottom: "1rem",
        display: "flex",
        justifyContent: "space-between",
      }}
    >
      <div key={file.name} style={{ display: "flex", alignItems: "center" }}>
        {file.type == "application/pdf" && (
          <InsertDriveFile sx={{ marginRight: "12px", color: "#F90000" }} />
        )}
        {file.type == "image/png" && (
          <InsertPhoto sx={{ marginRight: "12px", color: "#00b5a2" }} />
        )}

        {file.type == "image/jpeg" && (
          <InsertPhoto sx={{ marginRight: "12px", color: "#00b5a2" }} />
        )}

        <p style={{ margin: 0 }}>{file.name}</p>
      </div>
      <Close
        sx={{ color: "#F90000", zIndex: 1 }}
        onClick={() => handleDelete3(index)}
      />
    </div>
  ));

  const handleDelete = async (fileIndex) => {
    const updatedFiles = [...files];
    updatedFiles.splice(fileIndex, 1);
    setFiles(updatedFiles);
    setUploadPDF({
      file: "",
    });
    calculateCart();
  };

  const handleDelete2 = async (fileIndex) => {
    const updatedFiles = [...files2];
    updatedFiles.splice(fileIndex, 1);
    setFiles2(updatedFiles);
    setAttachment("");
    calculateCart();
  };

  const handleDelete3 = async (fileIndex) => {
    const updatedFiles = [...files3];
    updatedFiles.splice(fileIndex, 1);
    setFiles3(updatedFiles);
    setCustomerPO("");
    calculateCart();
  };


  const handleDirectCheckout = () => {
    setLoadingAdd(true);
    // console.log(selectedCustomer, selectedShippingCustomerAddress, productList, data)
    if (selectedCustomer === null) {
      setLoadingAdd(false);
      toast("Please Choose Customer");

      return;
    }
    // if (selectedBillingCustomerAddress === null) {
    //     toast('Please choose a billing address')
    //     return
    // }
    if (selectedShippingCustomerAddress === null) {
      setLoadingAdd(false);
      toast("Please Choose Shipping Address");
      return;
    }
    if (selectedShippingMethod.shipping_method_id === 0) {
      setLoadingAdd(false);
      toast("Please Choose Shipping Method");
      return;
    }
    if (
      shippingCarrier.length > 0 &&
      selectedShippingMethod.shipping_carrier_id === 0
    ) {
      setLoadingAdd(false);
      toast("Please Choose Shipping Carrier");
      return;
    }
    if (productList.length === 0) {
      setLoadingAdd(false);
      toast("Please add item");
      return;
    }

    var _productList = [...productList];
    for (var i = 0; i < _productList.length; i++) {
      _productList[i]["description"] = encodeURIComponent(
        _productList[i]["description"]
      );
    }

    var data = {
      ...selectedShippingMethod,
      ...remark,
      // ...discountData,
      ...uploadPDF,
      bypasscl: remark.bypasscl ? 1 : 0,
      item: JSON.stringify(_productList),
      shipping_fee: orderFee.shipping_fee,
      class: selectedClass,
      customer_contact_id: selectedCustomer.customer_contact_id,
      customer_address_id: selectedShippingCustomerAddress.customer_address_id,
      billing_address_id: selectedBillingCustomerAddress.customer_address_id,
      deposit_amount: deposit,
      merchandiser: selectedMerchandiser,
      salesrep: selectedRep,
      customorderpo: customerPO,
      attachment: attachment,
    };

    // console.log(data);
    // return;

    create_orders_admin(data).then((json) => {
      if (typeof json.status !== "undefined") {
        alert(json.message);
        setLoadingAdd(false);
        // return;
      } else {
        // setLoadingAdd(false);
        // return;
        navigate("/saledetail/" + json);
      }
    });
  };


  return (
    <React.Fragment>
      {loading ? (
        <div style={{ margin: "auto" }}>
          <Loader type="bubble-loop" bgColor="#1A5386" size={50} />
        </div>
      ) : (
        <React.Fragment>
          {page === "order" ? (
            <Navbar2
              children={
                <Section pd="2rem">
                  <React.Fragment>
                    <div>
                      <div
                        onClick={() => navigate(-1)}
                        style={{
                          cursor: "pointer",
                        }}
                      >
                        <Paragraph
                          color="#000"
                          bold="400"
                          size="12px"
                          margin="0 0 1rem"
                        >
                          &lt; Back
                        </Paragraph>
                      </div>
                      <div className={classes.theFlexHeader}>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          <Paragraph
                            color="#1A5386"
                            bold="600"
                            size="24px"
                            margin="0 10px 0 0"
                          >
                            Edit Cart
                          </Paragraph>
                        </div>

                        <div
                          className={classes.theFlexBtn}
                          style={{ marginBottom: "0" }}
                        ></div>
                      </div>
                      <div
                        style={{
                          borderBottom: "2px solid #707070",
                          padding: ".2rem 0",
                        }}
                      />
                      <br />
                      <Grid container spacing={3}>
                        <Grid item xs={12} sm={12} md={6}>
                          <Autocomplete
                            id="customer_contact_id"
                            value={selectedCustomer}
                            options={customer}
                            getOptionLabel={(option) =>
                              option.entityid + " - " + option.name
                            }
                            onChange={(e, value) => {
                              if (value != null) {
                                setSelectedCustomer({
                                  ...selectedCustomer,
                                  customer_contact_id:
                                    value.customer_contact_id,
                                  entityid: value.entityid,
                                  name: value.name,
                                  phone: value.phone,
                                  email: value.email,
                                  paymenttype: value.paymenttype,
                                  currency: value.currency,
                                  customer_id: value.customer_id,
                                  balance: value.balance,
                                  depositbalance: value.depositbalance,
                                });
                                handleGetShippingMethod(
                                  value.customer_contact_id
                                );
                                handleGetCustomerData(value.customer_id);
                                if (value.subsidiary == 2) {
                                  setBilltype("SST");
                                } else {
                                  setBilltype("GST");
                                }
                                getCustomerCart(value.customer_contact_id);
                                getInventory(value.customer_id);
                                setProductList([]);
                                calculateCart();
                              } else {
                                setSelectedCustomer(null);
                                setProductList([]);
                                calculateCart();
                              }
                            }}
                            style={{ width: "100%" }}
                            renderInput={(params) => (
                              <FormInput
                                {...params}
                                label="Customer*"
                                textLabelColor="#000"
                                placeholder="Please Choose Customer*"
                                name="customer"
                                border="1px solid #c5c5c5"
                              />
                            )}
                          />
                        </Grid>
                      </Grid>
                      <br />
                      <div
                        style={{
                          borderBottom: "2px solid #707070",
                          padding: ".2rem 0",
                        }}
                      />
                      <br />
                      <br />

                      {loadingCart ? (
                        <div style={{ margin: "auto" }}>
                          <Loader
                            type="bubble-loop"
                            bgColor="#1A5386"
                            size={50}
                          />
                        </div>
                      ) : (
                        <React.Fragment>
                          <Grid container spacing={3}>
                            <Grid item xs={12} sm={12} md={12}>
                              <Card className={classes.theCard}>
                                <div
                                  className={classes.theFlexHeader2}
                                  ref={OrderProductRef}
                                >
                                  <Paragraph
                                    color="#1A5386"
                                    size="22px"
                                    bold="600"
                                  >
                                    Product List
                                  </Paragraph>
                                  <div
                                    className={classes.theFlexBtn}
                                    style={{ marginBottom: "0" }}
                                  >
                                    <React.Fragment>
                                      {loadingItem ? (
                                        <div style={{ margin: "auto" }}>
                                          <Loader
                                            type="bubble-loop"
                                            bgColor="#1A5386"
                                            size={50}
                                          />
                                        </div>
                                      ) : (
                                        <a
                                          style={{
                                            border: 0,
                                            backgroundColor: "#1A5386",
                                            borderRadius: "10px",
                                          }}
                                          className={classes.theCustomActionBtn}
                                          onClick={() => handleGoItem()}
                                        >
                                          <AddCircle
                                            sx={{
                                              color: "#fff",
                                              marginRight: "8px",
                                            }}
                                          />
                                          <Paragraph
                                            size="16px"
                                            color="#fff"
                                            // margin="0 0 0 .4rem"
                                          >
                                            Add Item
                                          </Paragraph>
                                        </a>
                                      )}
                                    </React.Fragment>
                                  </div>
                                </div>
                                <br />
                                <div
                                  style={{
                                    borderBottom: "2px solid #707070",
                                  }}
                                ></div>
                                <br />
                                <TableContainer>
                                  <Table>
                                    <TableHead
                                      style={{ backgroundColor: "#fff" }}
                                    >
                                      <TableRow>
                                        <TableCell
                                          style={{
                                            borderRadius: "10px 0 0 10px",
                                          }}
                                          className={classes.theHeadTitle_}
                                        >
                                          Item Name
                                        </TableCell>
                                        <TableCell
                                          className={classes.theHeadTitle_}
                                        >
                                          Description
                                        </TableCell>
                                        <TableCell
                                          className={classes.theHeadTitle_}
                                        >
                                          Attributes
                                        </TableCell>

                                        <TableCell
                                          className={classes.theHeadTitle_}
                                        >
                                          Price
                                        </TableCell>
                                        <TableCell
                                          align="center"
                                          className={classes.theHeadTitle_}
                                        >
                                          Discount Amount
                                        </TableCell>
                                        <TableCell
                                          align="center"
                                          className={classes.theHeadTitle_}
                                        >
                                          Quantity
                                        </TableCell>
                                        <TableCell
                                          className={classes.theHeadTitle_}
                                        >
                                          Total Price
                                        </TableCell>
                                        <TableCell
                                          style={{
                                            borderRadius: "0 10px 10px 0",
                                          }}
                                          className={classes.theHeadTitle_}
                                        >
                                          <MoreVert sx={{ color: "#000" }} />
                                        </TableCell>
                                      </TableRow>
                                    </TableHead>
                                    <TableBody>
                                      {productList.length > 0 &&
                                        productList.map((item, index) => {
                                          return (
                                            <TableRow>
                                              <TableCell
                                                style={{
                                                  background:
                                                    index % 2 == 0
                                                      ? "#E0F0F7"
                                                      : "#fff",
                                                  width: "20%",
                                                }}
                                              >
                                                {item.itemname != "" &&
                                                item.itemname != null
                                                  ? item.itemname
                                                  : "-"}
                                              </TableCell>

                                              <TableCell
                                                style={{
                                                  background:
                                                    index % 2 == 0
                                                      ? "#E0F0F7"
                                                      : "#fff",
                                                  width: "20%",
                                                }}
                                              >
                                                <pre
                                                  style={{
                                                    margin: 0,
                                                    fontFamily:
                                                      "Roboto,Helvetica, Arial",
                                                  }}
                                                >
                                                  {item.description != "" &&
                                                  item.description != null
                                                    ? item.description
                                                    : "-"}
                                                </pre>
                                                <div
                                                  onClick={() =>
                                                    handleOpenAddIndexProduct(
                                                      item
                                                    )
                                                  }
                                                >
                                                  <Paragraph
                                                    textDecoration="underline"
                                                    margin="0"
                                                    color="#1A5386"
                                                  >
                                                    Edit Description
                                                  </Paragraph>
                                                </div>
                                              </TableCell>
                                              <TableCell
                                                style={{
                                                  background:
                                                    index % 2 == 0
                                                      ? "#E0F0F7"
                                                      : "#fff",
                                                  width: "10%",
                                                }}
                                              >
                                                Clr:{" "}
                                                {item.color != "" &&
                                                item.color != null
                                                  ? item.color
                                                  : "-"}
                                                <div>
                                                  Sz:{" "}
                                                  {item.size != "" &&
                                                  item.size != null
                                                    ? item.size
                                                    : "-"}
                                                </div>
                                              </TableCell>

                                              <TableCell
                                                style={{
                                                  background:
                                                    index % 2 == 0
                                                      ? "#E0F0F7"
                                                      : "#fff",
                                                  width: "10%",
                                                }}
                                              >
                                                {parseFloat(
                                                  item.given_price
                                                ).toFixed(4)}
                                              </TableCell>
                                              <TableCell
                                                style={{
                                                  background:
                                                    index % 2 == 0
                                                      ? "#E0F0F7"
                                                      : "#fff",
                                                }}
                                              >
                                                <div
                                                  style={{
                                                    // width: "60%",
                                                    margin: "0 auto",
                                                  }}
                                                >
                                                  <FormInput
                                                    border="1px solid #d7d7d7"
                                                    className="right"
                                                    type="number"
                                                    bg="#fff"
                                                    value={
                                                      item.given_discount !==
                                                        0 && item.given_discount
                                                    }
                                                    mb="0"
                                                    onChange={(e) =>
                                                      handleChangeDiscountText(
                                                        index,
                                                        e
                                                      )
                                                    }
                                                  />
                                                </div>
                                              </TableCell>
                                              <TableCell
                                                align="center"
                                                style={{
                                                  background:
                                                    index % 2 == 0
                                                      ? "#E0F0F7"
                                                      : "#fff",
                                                  width: "15%",
                                                }}
                                              >
                                                <div
                                                  style={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                  }}
                                                >
                                                  <RemoveCircle
                                                    sx={{
                                                      color: "#1A5386",
                                                      marginRight: "10px",
                                                    }}
                                                    onClick={() =>
                                                      handleChangeQty(index, -1)
                                                    }
                                                  />
                                                  <Box
                                                    sx={{
                                                      width: {
                                                        xs: "100px",
                                                        md: "40%",
                                                      },
                                                    }}
                                                  >
                                                    <FormInput
                                                      border="1px solid #d7d7d7"
                                                      className="right"
                                                      onKeyPress={(event) => {
                                                        if (
                                                          event.target.value ==
                                                            "" &&
                                                          !/[1-9]/.test(
                                                            event.key
                                                          )
                                                        ) {
                                                          event.preventDefault();
                                                        }
                                                      }}
                                                      inputProps={{
                                                        min: 1,
                                                        max: item.quantityavailable,
                                                      }}
                                                      bg="#fff"
                                                      value={item.quantity}
                                                      mb="0"
                                                      onChange={(e) =>
                                                        handleChangeQtyText(
                                                          index,
                                                          e
                                                        )
                                                      }
                                                    />
                                                  </Box>
                                                  <AddCircle
                                                    onClick={() =>
                                                      handleChangeQty(index, 1)
                                                    }
                                                    sx={{
                                                      color: "#1A5386",
                                                      marginLeft: "10px",
                                                    }}
                                                  />
                                                </div>
                                              </TableCell>
                                              <TableCell
                                                style={{
                                                  background:
                                                    index % 2 == 0
                                                      ? "#E0F0F7"
                                                      : "#fff",
                                                }}
                                              >
                                                {parseFloat(
                                                  item.given_subtotal
                                                ).toFixed(2)}
                                              </TableCell>
                                              <TableCell
                                                style={{
                                                  background:
                                                    index % 2 == 0
                                                      ? "#E0F0F7"
                                                      : "#fff",
                                                }}
                                              >
                                                <Close
                                                  sx={{ color: "#C52626" }}
                                                  onClick={() =>
                                                    handleRemoveItem(index)
                                                  }
                                                />
                                              </TableCell>
                                            </TableRow>
                                          );
                                        })}
                                    </TableBody>
                                  </Table>
                                </TableContainer>
                                <br />
                                <div
                                  style={{
                                    borderBottom: "2px solid #f2f2f2",
                                  }}
                                ></div>
                                <br />
                                <Grid container spacing={3}>
                                  <Grid item xs={12} sm={6}></Grid>
                                  <Grid item xs={12} sm={6}>
                                    <div className={classes.theTotal}>
                                      <Grid container spacing={3}>
                                        <Grid item xs={6} sm={6} md={6}>
                                          <Paragraph size="14px">
                                            Amount:
                                          </Paragraph>
                                        </Grid>
                                        <Grid item xs={6} sm={6} md={6}>
                                          <Paragraph
                                            size="14px"
                                            bold="600"
                                            style={{ textAlign: "right" }}
                                          >
                                            {orderFee.total_amount}
                                          </Paragraph>
                                        </Grid>
                                        <Grid item xs={6} sm={6} md={6}>
                                          <Paragraph size="14px">
                                            Discount Amount:
                                          </Paragraph>
                                        </Grid>
                                        <Grid item xs={6} sm={6} md={6}>
                                          <Paragraph
                                            size="14px"
                                            bold="600"
                                            style={{ textAlign: "right" }}
                                          >
                                            {orderFee.discountamount}
                                          </Paragraph>
                                        </Grid>
                                        <Grid item xs={6} sm={6} md={6}>
                                          <Paragraph size="14px">
                                            Shipping Fee:
                                          </Paragraph>
                                        </Grid>
                                        <Grid item xs={6} sm={6} md={6}>
                                          <Paragraph
                                            size="14px"
                                            bold="600"
                                            style={{ textAlign: "right" }}
                                          >
                                            {orderFee.shipping_fee}
                                          </Paragraph>
                                        </Grid>
                                        <Grid item xs={6} sm={6} md={6}>
                                          <Paragraph size="14px">
                                            Handling Fee:
                                          </Paragraph>
                                        </Grid>
                                        <Grid item xs={6} sm={6} md={6}>
                                          <Paragraph
                                            size="14px"
                                            bold="600"
                                            style={{ textAlign: "right" }}
                                          >
                                            {orderFee.handling_fee}
                                          </Paragraph>
                                        </Grid>
                                      </Grid>
                                    </div>
                                    <br />
                                    <div
                                      style={{
                                        borderBottom: "2px solid #f2f2f2",
                                      }}
                                    ></div>
                                    <br />
                                    <div className={classes.theTotal}>
                                      <Grid container spacing={3}>
                                        {billtype != null && (
                                          <React.Fragment>
                                            <Grid item xs={6} sm={6} md={6}>
                                              <Paragraph size="14px">
                                                {billtype}:
                                              </Paragraph>
                                            </Grid>
                                            <Grid item xs={6} sm={6} md={6}>
                                              <Paragraph
                                                size="14px"
                                                bold="600"
                                                style={{ textAlign: "right" }}
                                              >
                                                {orderFee.tax_fee}
                                              </Paragraph>
                                            </Grid>
                                          </React.Fragment>
                                        )}
                                        <Grid item xs={6} sm={6} md={6}>
                                          <Paragraph size="14px">
                                            Total:
                                          </Paragraph>
                                        </Grid>
                                        <Grid item xs={6} sm={6} md={6}>
                                          <Paragraph
                                            size="14px"
                                            bold="600"
                                            style={{ textAlign: "right" }}
                                          >
                                            {orderFee.final_amount}
                                          </Paragraph>
                                        </Grid>
                                      </Grid>
                                    </div>
                                  </Grid>
                                </Grid>

                                <br />
                                <div
                                  style={{
                                    borderBottom: "2px solid #f2f2f2",
                                  }}
                                ></div>
                                <br />
                              </Card>
                              <br />
                              <br />
                            </Grid>
                          </Grid>

                          <div
                            className={classes.theFlexBtn}
                            style={{ marginBottom: "0" }}
                          >
                            <a
                              className={classes.theAddCustomActionBtnFill}
                              onClick={() => handleOpenDirectCheckout()}
                              // onClick={() => alert("Coming Soon")}
                            >
                              <Paragraph margin="0 0 0 .4rem">
                                Direct Checkout
                              </Paragraph>
                            </a>

                            {loadingAdd ? (
                              <div style={{ margin: "auto" }}>
                                <Loader
                                  type="bubble-loop"
                                  bgColor="#1A5386"
                                  size={50}
                                />
                              </div>
                            ) : (
                              <a
                                className={classes.theAddCustomActionBtnFill}
                                onClick={() => handleSubmitOrder()}
                              >
                                <Paragraph margin="0 0 0 .4rem">
                                  Save Cart
                                </Paragraph>
                              </a>
                            )}
                          </div>
                        </React.Fragment>
                      )}
                      <br />
                      <br />
                    </div>
                  </React.Fragment>
                </Section>
              }
            />
          ) : (
            <Navbar2
              children={
                <Section pd="2rem">
                  <div>
                    <div
                      onClick={() => {
                        setPage("order");
                        window.scrollTo({
                          top: 0,
                          behavior: "smooth",
                        });
                      }}
                      style={{
                        cursor: "pointer",
                      }}
                    >
                      <Paragraph
                        color="#1A5386"
                        bold="400"
                        size="12px"
                        margin="0 0 1rem"
                      >
                        &lt; Back
                      </Paragraph>
                    </div>
                    <div className={classes.theFlexHeader}>
                      <Paragraph color="#1A5386" bold="600" size="24px">
                        Product List
                      </Paragraph>
                    </div>
                    <div
                      style={{
                        borderBottom: "2px solid #707070",
                        padding: ".2rem 0",
                      }}
                    />
                    <br />

                    <div className={classes.theFlexAction}>
                      <div
                        style={{
                          display: "flex",
                        }}
                      >
                        <div
                          className={classes.theWx}
                          style={{ margin: "0 20px 0 0", width: "100%" }}
                        >
                          <FormInputNoLabel
                            placeholder="Search"
                            border="1px solid #d7d7d7"
                            br="6px"
                            onChange={handleSearch}
                            value={searchKey}
                          />
                        </div>
                        <div
                          className={classes.theWx}
                          style={{ margin: "0 20px 0 0", width: "100%" }}
                        >
                          <FormInputNoLabel
                            name="color"
                            placeholder="Search"
                            border="1px solid #d7d7d7"
                            br="6px"
                            onChange={(e) => setColorSort(e.target.value)}
                            value={colorSort}
                            select
                          >
                            <MenuItem value="All">Select a Color</MenuItem>
                            {colorData != null &&
                              colorData.map((res) => (
                                <MenuItem
                                  value={res.colorname}
                                  style={{ color: "#000" }}
                                >
                                  {res.colorname}
                                </MenuItem>
                              ))}
                          </FormInputNoLabel>
                        </div>
                      </div>
                      <div className={classes.theFlex_}>
                        <div
                          className={
                            viewType == "grid"
                              ? classes.theIconButtonSelected
                              : classes.theIconButton
                          }
                          onClick={() => setViewType("grid")}
                        >
                          <GridView
                            sx={{
                              color: viewType == "grid" ? "#fff" : "#1A5386",
                              fontSize: "1.2rem",
                            }}
                          />
                        </div>
                        <div
                          className={
                            viewType == "list"
                              ? classes.theIconButtonSelected
                              : classes.theIconButton
                          }
                          onClick={() => setViewType("list")}
                        >
                          <List
                            sx={{
                              color: viewType == "list" ? "#fff" : "#1A5386",
                              fontSize: "1.2rem",
                            }}
                          />
                        </div>
                      </div>
                    </div>

                    <Grid container spacing={3}>
                      <Grid item xs={12} sm={12} md={12}>
                        <Card className={classes.theCard}>
                          <TableContainer>
                            <Table>
                              <TableHead style={{ backgroundColor: "#1A5386" }}>
                                <TableRow>
                                  <TableCell
                                    style={{ borderRadius: "10px 0 0 10px" }}
                                    className={classes.theHeadTitle}
                                  >
                                    Item Name
                                  </TableCell>
                                  <TableCell className={classes.theHeadTitle}>
                                    Size
                                  </TableCell>
                                  <TableCell className={classes.theHeadTitle}>
                                    Color
                                  </TableCell>
                                  <TableCell className={classes.theHeadTitle}>
                                    Quantity
                                  </TableCell>
                                  <TableCell className={classes.theHeadTitle}>
                                    Price
                                  </TableCell>
                                  <TableCell className={classes.theHeadTitle}>
                                    Sale Unit
                                  </TableCell>
                                  <TableCell className={classes.theHeadTitle}>
                                    Brand
                                  </TableCell>
                                  <TableCell
                                    style={{ borderRadius: "0 10px 10px 0" }}
                                    className={classes.theHeadTitle}
                                  >
                                    <MoreVert sx={{ color: "#fff" }} />
                                  </TableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {inventory != null &&
                                  inventory
                                    .slice(pageNum * 10, pageNum * 10 + 10)
                                    .map((item, index) => {
                                      return (
                                        <React.Fragment>
                                          <TableRow>
                                            <TableCell
                                              className={classes.theDetailRow}
                                              style={{
                                                width: "25%",
                                                background:
                                                  index % 2 == 0
                                                    ? "#E0F0F7"
                                                    : "#fff",
                                              }}
                                            >
                                              {item.itemname != "" &&
                                              item.itemname != null
                                                ? item.itemname
                                                : "-"}
                                              <div>
                                                {item.displayname != "" &&
                                                item.displayname != null
                                                  ? item.displayname
                                                  : "-"}
                                              </div>
                                            </TableCell>
                                            <TableCell
                                              className={classes.theDetailRow}
                                              style={{
                                                width: "10%",
                                                background:
                                                  index % 2 == 0
                                                    ? "#E0F0F7"
                                                    : "#fff",
                                              }}
                                            >
                                              {item.size != "" &&
                                              item.size != null
                                                ? item.size
                                                : "-"}
                                            </TableCell>
                                            <TableCell
                                              className={classes.theDetailRow}
                                              style={{
                                                width: "10%",
                                                background:
                                                  index % 2 == 0
                                                    ? "#E0F0F7"
                                                    : "#fff",
                                              }}
                                            >
                                              {item.colorname != "" &&
                                              item.colorname != null
                                                ? item.colorname
                                                : "-"}
                                            </TableCell>
                                            <TableCell
                                              className={classes.theDetailRow}
                                              style={{
                                                width: "15%",
                                                background:
                                                  index % 2 == 0
                                                    ? "#E0F0F7"
                                                    : "#fff",
                                              }}
                                            >
                                              -
                                            </TableCell>
                                            <TableCell
                                              className={classes.theDetailRow}
                                              style={{
                                                width: "10%",
                                                background:
                                                  index % 2 == 0
                                                    ? "#E0F0F7"
                                                    : "#fff",
                                              }}
                                            >
                                              {item.price != "" &&
                                              item.price != null
                                                ? item.price
                                                : "-"}
                                            </TableCell>
                                            <TableCell
                                              className={classes.theDetailRow}
                                              style={{
                                                width: "10%",
                                                background:
                                                  index % 2 == 0
                                                    ? "#E0F0F7"
                                                    : "#fff",
                                              }}
                                            >
                                              {item.saleunit != "" &&
                                              item.saleunit != null
                                                ? item.saleunit
                                                : "-"}
                                            </TableCell>

                                            <TableCell
                                              className={classes.theDetailRow}
                                              style={{
                                                width: "10%",
                                                background:
                                                  index % 2 == 0
                                                    ? "#E0F0F7"
                                                    : "#fff",
                                              }}
                                            >
                                              {item.brand != "" &&
                                              item.brand != null
                                                ? item.brand
                                                : "-"}
                                            </TableCell>
                                            <TableCell
                                              className={classes.theDetailRow}
                                              style={{
                                                width: "10%",
                                                background:
                                                  index % 2 == 0
                                                    ? "#E0F0F7"
                                                    : "#fff",
                                                cursor: "pointer",
                                              }}
                                              // onClick={() =>
                                              //   item.type === "Matrix Item"
                                              //     ? handleChangeTable(index)
                                              //     : item.inactive == 1
                                              //     ? toast(
                                              //         "This item is unavailable"
                                              //       )
                                              //     : handleOpen(item)
                                              // }
                                              onClick={() =>
                                                item.type === "Matrix Item"
                                                  ? handleChangeTable(item)
                                                  : item.inactive == 1
                                                  ? toast(
                                                      "This item is unavailable"
                                                    )
                                                  : handleOpen(item)
                                              }
                                            >
                                              {item.type === "Matrix Item" ? (
                                                item.openTable ? (
                                                  <ArrowCircleUp
                                                    sx={{ color: "#1A5386" }}
                                                  />
                                                ) : (
                                                  <ArrowCircleDown
                                                    sx={{ color: "#1A5386" }}
                                                  />
                                                )
                                              ) : (
                                                <AddCircle
                                                  sx={{
                                                    color:
                                                      item.inactive == 1
                                                        ? "#9e9e9e"
                                                        : "#1A5386",
                                                  }}
                                                />
                                              )}
                                            </TableCell>
                                          </TableRow>
                                          {item.type === "Matrix Item" && (
                                            <TableRow>
                                              <TableCell
                                                className={
                                                  classes.theDetailOpen
                                                }
                                                colSpan={8}
                                              >
                                                <Collapse
                                                  // in={item.openTable}
                                                  in={open[item.item_id]}
                                                  timeout="auto"
                                                  unmountOnExit
                                                >
                                                  {viewType == "list" ? (
                                                    <Table>
                                                      {item.children.map(
                                                        (res, resindex) => (
                                                          <TableBody>
                                                            <TableRow>
                                                              <TableCell
                                                                style={{
                                                                  width: "25%",
                                                                  background:
                                                                    index % 2 ==
                                                                    0
                                                                      ? "#E0F0F7"
                                                                      : "#fff",
                                                                }}
                                                              >
                                                                <SubdirectoryArrowRight
                                                                  sx={{
                                                                    color:
                                                                      "#1A5386",
                                                                  }}
                                                                />
                                                                {res.itemname}
                                                                <div>
                                                                  {
                                                                    res.displayname
                                                                  }
                                                                </div>
                                                              </TableCell>
                                                              <TableCell
                                                                style={{
                                                                  width: "10%",
                                                                  background:
                                                                    index % 2 ==
                                                                    0
                                                                      ? "#E0F0F7"
                                                                      : "#fff",
                                                                }}
                                                              >
                                                                {res.size}
                                                              </TableCell>
                                                              <TableCell
                                                                style={{
                                                                  width: "10%",
                                                                  background:
                                                                    index % 2 ==
                                                                    0
                                                                      ? "#E0F0F7"
                                                                      : "#fff",
                                                                }}
                                                              >
                                                                {res.colorname}
                                                              </TableCell>
                                                              <TableCell
                                                                style={{
                                                                  width: "15%",
                                                                  background:
                                                                    index % 2 ==
                                                                    0
                                                                      ? "#E0F0F7"
                                                                      : "#fff",
                                                                }}
                                                              >
                                                                On Hand:{" "}
                                                                {
                                                                  res.quantityonhand
                                                                }
                                                                <div>
                                                                  Free to use:{" "}
                                                                  {
                                                                    res.quantityavailable
                                                                  }
                                                                </div>
                                                              </TableCell>
                                                              <TableCell
                                                                style={{
                                                                  width: "10%",
                                                                  background:
                                                                    index % 2 ==
                                                                    0
                                                                      ? "#E0F0F7"
                                                                      : "#fff",
                                                                }}
                                                              >
                                                                {res.price}
                                                              </TableCell>
                                                              <TableCell
                                                                style={{
                                                                  width: "10%",
                                                                  background:
                                                                    index % 2 ==
                                                                    0
                                                                      ? "#E0F0F7"
                                                                      : "#fff",
                                                                }}
                                                              >
                                                                {res.saleunit}
                                                              </TableCell>
                                                              <TableCell
                                                                style={{
                                                                  width: "10%",
                                                                  background:
                                                                    index % 2 ==
                                                                    0
                                                                      ? "#E0F0F7"
                                                                      : "#fff",
                                                                }}
                                                              >
                                                                {res.brand !=
                                                                  "" &&
                                                                res.brand !=
                                                                  null
                                                                  ? res.brand
                                                                  : "-"}
                                                              </TableCell>
                                                              <TableCell
                                                                style={{
                                                                  width: "10%",
                                                                  background:
                                                                    index % 2 ==
                                                                    0
                                                                      ? "#E0F0F7"
                                                                      : "#fff",
                                                                  cursor:
                                                                    "pointer",
                                                                }}
                                                                onClick={() =>
                                                                  res.price ==
                                                                    0 ||
                                                                  res.inactive ==
                                                                    1
                                                                    ? toast(
                                                                        "This item is unavailable"
                                                                      )
                                                                    : handleOpen(
                                                                        res
                                                                      )
                                                                }
                                                              >
                                                                <AddCircle
                                                                  sx={{
                                                                    color:
                                                                      item.inactive ==
                                                                      1
                                                                        ? "#9e9e9e"
                                                                        : "#1A5386",
                                                                  }}
                                                                />
                                                              </TableCell>
                                                            </TableRow>
                                                          </TableBody>
                                                        )
                                                      )}
                                                    </Table>
                                                  ) : (
                                                    <div
                                                      className={
                                                        index % 2 == 0
                                                          ? classes.theGridOdd
                                                          : classes.theGridEven
                                                      }
                                                    >
                                                      {item.children_grid.map(
                                                        (
                                                          resCGrid,
                                                          resindex
                                                        ) => (
                                                          <div
                                                            className={
                                                              classes.theGFlex
                                                            }
                                                          >
                                                            <div
                                                              className={
                                                                classes.theGFName
                                                              }
                                                            >
                                                              <Paragraph
                                                                color="#000"
                                                                bold="600"
                                                                size="0.875rem"
                                                              >
                                                                {
                                                                  resCGrid[0]
                                                                    .color
                                                                }
                                                              </Paragraph>
                                                              <Paragraph
                                                                color="#000"
                                                                bold="600"
                                                                size="0.875rem"
                                                              >
                                                                {
                                                                  resCGrid[0]
                                                                    .cataloguedescription
                                                                }
                                                              </Paragraph>
                                                            </div>
                                                            <div
                                                              className={
                                                                classes.theGFItem
                                                              }
                                                            >
                                                              {resCGrid.map(
                                                                (
                                                                  resGGM,
                                                                  resindex
                                                                ) => (
                                                                  <div
                                                                    className={
                                                                      classes.theGFIBox
                                                                    }
                                                                  >
                                                                    <Paragraph
                                                                      bold="500"
                                                                      margin="0 0 .4rem 0"
                                                                      center
                                                                    >
                                                                      {
                                                                        resGGM.size
                                                                      }
                                                                    </Paragraph>

                                                                    <FormInput
                                                                      border="1px solid #d7d7d7"
                                                                      name="quantity"
                                                                      onChange={(
                                                                        e
                                                                      ) =>
                                                                        handleChangeGrid(
                                                                          e,
                                                                          index
                                                                        )
                                                                      }
                                                                      className="customTextField"
                                                                      id={
                                                                        resGGM.internalid +
                                                                        "_" +
                                                                        resGGM.hscode +
                                                                        "_" +
                                                                        resGGM.itemname +
                                                                        "_" +
                                                                        resGGM.price +
                                                                        "_" +
                                                                        resGGM.type +
                                                                        "_" +
                                                                        resGGM.color +
                                                                        "_" +
                                                                        resGGM.quantityavailable +
                                                                        "_" +
                                                                        resGGM.size
                                                                      }
                                                                      center
                                                                      onKeyPress={(
                                                                        event
                                                                      ) => {
                                                                        if (
                                                                          event
                                                                            .target
                                                                            .value ==
                                                                            "" &&
                                                                          !/[1-9]/.test(
                                                                            event.key
                                                                          )
                                                                        ) {
                                                                          event.preventDefault();
                                                                        }
                                                                      }}
                                                                      inputProps={{
                                                                        min: 1,
                                                                        max: resGGM.quantityavailable,
                                                                      }}
                                                                      bg={
                                                                        resGGM.price ==
                                                                          0 ||
                                                                        resGGM.inactive ==
                                                                          1
                                                                          ? "#d7d7d7"
                                                                          : "#fff"
                                                                      }
                                                                      disabled={
                                                                        resGGM.price ==
                                                                          0 ||
                                                                        resGGM.inactive ==
                                                                          1
                                                                          ? true
                                                                          : false
                                                                      }
                                                                    />

                                                                    <Paragraph
                                                                      style={{
                                                                        fontStyle:
                                                                          "italic",
                                                                      }}
                                                                      margin="0"
                                                                      bold="600"
                                                                      center
                                                                      color={resGGM.bestbuy == 1 ? "#C52626" : "#707070"}
                                                                    >
                                                                      {
                                                                        selectedCustomer.currency
                                                                      }{" "}
                                                                      {parseFloat(
                                                                        resGGM.price
                                                                      )}
                                                                    </Paragraph>
                                                                    <Paragraph
                                                                      style={{
                                                                        fontStyle:
                                                                          "italic",
                                                                      }}
                                                                      margin="0"
                                                                      center
                                                                      color="#C52626"
                                                                    >
                                                                      On Hand:{" "}
                                                                      {
                                                                        resGGM.quantityonhand
                                                                      }
                                                                    </Paragraph>
                                                                    <Paragraph
                                                                      style={{
                                                                        fontStyle:
                                                                          "italic",
                                                                      }}
                                                                      margin="0"
                                                                      center
                                                                      color="#C52626"
                                                                    >
                                                                      Free to
                                                                      use:{" "}
                                                                      {
                                                                        resGGM.quantityavailable
                                                                      }
                                                                    </Paragraph>

                                                                    <input
                                                                      value={
                                                                        resGGM.internalid
                                                                      }
                                                                      name="id"
                                                                      onChange={(
                                                                        e
                                                                      ) =>
                                                                        handleChangeGrid(
                                                                          e,
                                                                          index
                                                                        )
                                                                      }
                                                                      type="hidden"
                                                                    />
                                                                  </div>
                                                                )
                                                              )}
                                                            </div>
                                                          </div>
                                                        )
                                                      )}
                                                    </div>
                                                  )}
                                                </Collapse>
                                              </TableCell>
                                            </TableRow>
                                          )}
                                        </React.Fragment>
                                      );
                                    })}
                              </TableBody>
                            </Table>
                          </TableContainer>

                          <div
                            style={{
                              borderTop: "1px solid #707070",
                              borderBottom: "1px solid #707070",
                              margin: "1rem 0 0",
                              cursor: "pointer",
                              display: "flex",
                              justifyContent: "flex-end",
                              alignItems: "flex-end",
                            }}
                          >
                            <TablePagination
                              color="primary"
                              page={pageNum}
                              onPageChange={handleChangePage}
                              count={totalList}
                              rowsPerPage={10}
                              rowsPerPageOptions={[10]}
                            />
                          </div>
                        </Card>
                        <br />
                        <br />
                      </Grid>
                    </Grid>
                    <br />
                  </div>
                  {selectedItem != null && (
                    <Dialog
                      onClose={handleClose}
                      open={open}
                      fullWidth="true"
                      maxWidth="sm"
                    >
                      <DialogTitle>
                        <Paragraph
                          color="#1A5386"
                          bold="600"
                          size="24px"
                          center
                        >
                          Enter Detail
                        </Paragraph>
                      </DialogTitle>
                      <DialogContent>
                        <div className={classes.theQuantityBox}>
                          <RemoveCircle
                            sx={{ fontSize: "2rem", color: "#1A5386" }}
                            onClick={() =>
                              selectedItem.quantity > 1 &&
                              setSelectedItem({
                                ...selectedItem,
                                quantity: parseInt(selectedItem.quantity) - 1,
                              })
                            }
                          />
                          <div className={classes.theQuantityField}>
                            <FormInput
                              value={
                                selectedItem !== null && selectedItem.quantity
                              }
                              textLabelColor="#000"
                              name="quantity"
                              border="1px solid #c5c5c5"
                              mb="0"
                              onKeyPress={(event) => {
                                if (
                                  event.target.value === "" &&
                                  !/-?[0-9]/.test(event.key)
                                ) {
                                  event.preventDefault();
                                }
                              }}
                              inputProps={{ min: 1 }}
                              center
                              onChange={handleChangeProduct2}
                            />
                          </div>
                          <AddCircle
                            onClick={() =>
                              setSelectedItem({
                                ...selectedItem,
                                quantity: parseInt(selectedItem.quantity) + 1,
                              })
                            }
                            sx={{ fontSize: "2rem", color: "#1A5386" }}
                          />
                        </div>
                        <div className={classes.theQuantityBox}>
                          <div className={classes.theQuantityField}>
                            <FormInput
                              value={
                                selectedItem !== null && selectedItem.price
                              }
                              textLabelColor="#000"
                              disabled={
                                selectedItem != null &&
                                selectedItem.type != "Matrix Item"
                                  ? false
                                  : true
                              }
                              name="price"
                              placeholder="Price"
                              onKeyPress={(event) => {
                                if (
                                  event.target.value == "" &&
                                  !/[1-9]/.test(event.key)
                                ) {
                                  event.preventDefault();
                                }
                              }}
                              inputProps={{ min: 0 }}
                              border="1px solid #c5c5c5"
                              mb="0"
                              onChange={handleChangeProduct}
                            />
                          </div>
                        </div>
                        <div className={classes.theQuantityBox}>
                          <div className={classes.theQuantityField}>
                            <FormInput
                              value={
                                selectedItem !== null &&
                                selectedItem.description
                              }
                              textLabelColor="#000"
                              name="description"
                              placeholder="Description"
                              border="1px solid #c5c5c5"
                              mb="0"
                              multiline
                              minRows={4}
                              onChange={handleChangeProduct}
                            />
                          </div>
                        </div>
                        <div className={classes.theQuantityBox}>
                          <div className={classes.theQuantityField}>
                            <Button
                              onClick={() =>
                                selectedItem.type == "Matrix Item" &&
                                selectedItem.price == 0
                                  ? toast("Invalid Price")
                                  : addProduct()
                              }
                              label="Confirm"
                              color="#fff"
                              bg={
                                selectedItem.type == "Matrix Item" &&
                                selectedItem.price == 0
                                  ? "#c5c5c5"
                                  : "#1A5386"
                              }
                              size="18px"
                              pd="10px"
                              br="5px"
                              style={{ marginBottom: "10px" }}
                            />
                          </div>
                        </div>
                      </DialogContent>
                    </Dialog>
                  )}

                  <div
                    className={classes.theFloatCart}
                    style={{
                      display: displayFloat ? "block" : "none",
                    }}
                  >
                    <div className={classes.theFCHeader}>
                      <Paragraph color="#fff" bold="600" size="14px">
                        Added Product List
                      </Paragraph>
                    </div>
                    <div className={classes.theFCTable}>
                      <TableContainer style={{ maxHeight: 300 }}>
                        <Table>
                          <TableHead style={{ backgroundColor: "#fff" }}>
                            <TableRow>
                              <TableCell className={classes.theCartTitle}>
                                Item Name
                              </TableCell>
                              <TableCell className={classes.theCartTitle}>
                                Quantity
                              </TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {productList.length > 0 &&
                              productList.map((productRest, index) => (
                                <TableRow>
                                  <TableCell
                                    style={{
                                      width: "80%",
                                    }}
                                  >
                                    {productRest.itemname != "" &&
                                    productRest.itemname != null
                                      ? productRest.itemname
                                      : "-"}
                                  </TableCell>
                                  <TableCell
                                    align="center"
                                    style={{
                                      width: "20%",
                                    }}
                                  >
                                    {productRest.quantity}
                                  </TableCell>
                                </TableRow>
                              ))}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </div>
                    <div className={classes.theFCFooter}>
                      <div
                        className={classes.theCheckoutBtn}
                        style={{ margin: "0 10px 0 0" }}
                      >
                        <Button
                          label="Back"
                          color="#FFF"
                          bg="#1A5386"
                          br="4px"
                          pd=".4rem 1.2rem"
                          size="14px"
                          onClick={() => {
                            setPage("order");
                            calculateCart();
                            setTimeout(() => {
                              OrderProductRef.current.scrollIntoView({
                                behavior: "smooth",
                              });
                            }, 300);
                          }}
                        />
                      </div>
                      <div className={classes.theCheckoutBtn}>
                        <Button
                          label="Proceed to cart"
                          color="#FFF"
                          bg="#1A5386"
                          br="4px"
                          pd=".4rem 1.2rem"
                          size="14px"
                          onClick={() => {
                            setPage("order");
                            calculateCart();
                            setDisplayFloat(false);
                            setTimeout(() => {
                              OrderProductRef.current.scrollIntoView({
                                behavior: "smooth",
                              });
                            }, 300);
                          }}
                        />
                      </div>
                    </div>
                  </div>

                  <div
                    className={classes.theShirtIcon}
                    onClick={() => setDisplayFloat(!displayFloat)}
                  >
                    <div className={classes.theSIImage}>
                      <img src={ShirtIcon} />
                    </div>
                    <div
                      style={{
                        backgroundColor: "#C52626",
                        width: "25px",
                        height: "25px",
                        position: "absolute",
                        top: "-6px",
                        right: "-6px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        borderRadius: "50%",
                      }}
                    >
                      <Paragraph color="#fff" bold="600" size="12px">
                        {productList.length}
                      </Paragraph>
                    </div>
                  </div>
                </Section>
              }
            />
          )}
        </React.Fragment>
      )}

      <>
        {selectedIndexProduct != null && (
          <Dialog
            onClose={handleCloseIndexProduct}
            open={openEditDesc}
            fullWidth="true"
            maxWidth="sm"
          >
            <DialogTitle>
              <Paragraph color="#1A5386" bold="600" size="24px">
                Edit Description
              </Paragraph>
            </DialogTitle>
            <DialogContent>
              <Grid container spacing={3}>
                <Grid item xs={12} sm={12} md={12}>
                  <FormInput
                    value={
                      selectedIndexProduct !== null &&
                      selectedIndexProduct.description
                    }
                    textLabelColor="#000"
                    name="description"
                    placeholder="Description"
                    border="1px solid #c5c5c5"
                    mb="1rem"
                    multiline
                    minRows={4}
                    onChange={handleChangeIndexProduct}
                  />
                </Grid>
              </Grid>
              <Button
                onClick={() => handleCloseIndexProduct()}
                label="Save"
                color="#fff"
                bg="#1A5386"
                size="18px"
                pd="10px"
                br="5px"
                style={{ marginBottom: "10px" }}
              />
            </DialogContent>
          </Dialog>
        )}
      </>

      <Dialog
        onClose={() => setOpenDirectCheckout(false)}
        open={openDirectCheckout}
        fullWidth="true"
        maxWidth="md"
      >
        {/* <DialogTitle>
          <Paragraph color="#1A5386" bold="600" size="24px">
            Direct Checkout
          </Paragraph>
        </DialogTitle> */}
        <DialogContent>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={12} md={6}>
              <Autocomplete
                id="customer_address_id"
                value={selectedBillingCustomerAddress}
                disabled={true}
                options={customerAddress}
                getOptionLabel={(option) =>
                  option.addr1 +
                  ", " +
                  option.addr2 +
                  " " +
                  option.city +
                  " " +
                  option.zip +
                  ", " +
                  option.state +
                  ", " +
                  option.country
                }
                onChange={(e, value) => {
                  // console.log('value', value)
                  if (value != null) {
                    setSelectedBillingCustomerAddress({
                      ...selectedBillingCustomerAddress,
                      customer_address_id: value.customer_address_id,
                      addr1: value.addr1,
                      addr2: value.addr2,
                      city: value.city,
                      zip: value.zip,
                      state: value.state,
                      country: value.country,
                    });
                  } else {
                    setSelectedBillingCustomerAddress({
                      ...selectedBillingCustomerAddress,
                      customer_address_id: "",
                      addr1: "",
                      addr2: "",
                      city: "",
                      zip: "",
                      state: "",
                      country: "",
                    });
                  }
                }}
                style={{ width: "100%" }}
                renderInput={(params) => (
                  <FormInput
                    {...params}
                    label="Billing Address*"
                    // value={addressData.addr1}
                    textLabelColor="#000"
                    placeholder={
                      customerAddress.length == 0
                        ? "Please Choose Customer"
                        : "Please Choose Billing Address"
                    }
                    name="customer_address_id"
                    border="1px solid #c5c5c5"
                    padding="0.6rem 4rem 0.6rem 1rem"
                    bg={"#c5c5c5"}
                    inputProps={{
                      ...params.inputProps,
                      autoComplete: "new-password",
                    }}
                  />
                )}
              />

              <FormInput
                label="Class"
                value={selectedClass}
                textcolor="#707070"
                placeholder="Class"
                name="class"
                bg="#fff"
                border="1px solid #c5c5c5"
                select
                onChange={(e) => setSelectedClass(e.target.value)}
              >
                {classList != null &&
                  classList.map((res) => (
                    <MenuItem value={res.class} style={{ color: "#000" }}>
                      {res.name}
                    </MenuItem>
                  ))}
              </FormInput>
              <FormInput
                label="Merchandiser"
                value={selectedMerchandiser}
                textcolor="#707070"
                placeholder="Class"
                name="class"
                bg="#fff"
                border="1px solid #c5c5c5"
                select
                onChange={(e) => setSelectedMerchandiser(e.target.value)}
              >
                <MenuItem value={0} style={{ color: "#000" }}>
                  Please Select a Merchansider
                </MenuItem>
                {merchandiser != null &&
                  merchandiser.map((res) => (
                    <MenuItem value={res.internalid} style={{ color: "#000" }}>
                      {res.entityid}
                    </MenuItem>
                  ))}
              </FormInput>
              <FormInput
                label="Sales Rep"
                value={selectedRep}
                textcolor="#707070"
                placeholder="Sales Rep"
                name="sales_rep"
                bg="#fff"
                border="1px solid #c5c5c5"
                select
                onChange={(e) => setSelectedRep(e.target.value)}
              >
                <MenuItem value={0} disabled style={{ color: "#000" }}>
                  None
                </MenuItem>
                {rep != null &&
                  rep.map((res) => (
                    <MenuItem value={res.internalid} style={{ color: "#000" }}>
                      {res.entityid}
                    </MenuItem>
                  ))}
              </FormInput>
              <FormInput
                label="Shipping Method*"
                value={selectedShippingMethod.shipping_method_id}
                textcolor="#707070"
                placeholder="Shipping Method"
                name="shipping_method_id"
                border="1px solid #c5c5c5"
                select
                disabled={shippingMethod.length == 0 ? true : false}
                bg={shippingMethod.length == 0 ? "#c5c5c5" : "#fff"}
                // onChange={(e) => }
              >
                <MenuItem value={0} disabled style={{ color: "#000" }}>
                  Please Select Shipping Method
                </MenuItem>
                {shippingMethod.length != 0 &&
                  shippingMethod.map((res) => (
                    <MenuItem
                      value={res.shipping_method_id}
                      style={{ color: "#000" }}
                      onClick={() => handleChangeShippingMethod(res)}
                    >
                      {res.shippingmethod}
                    </MenuItem>
                  ))}
              </FormInput>
              <FormInput
                label="Shipping Carrier*"
                value={selectedShippingMethod.shipping_carrier_id}
                textcolor="#707070"
                placeholder="Shipping Carrier"
                name="shipping_carrier_id"
                border="1px solid #c5c5c5"
                select
                disabled={shippingCarrier.length == 0 ? true : false}
                bg={shippingCarrier.length == 0 ? "#c5c5c5" : "#fff"}
                // onChange={(e) => }
              >
                <MenuItem value={0} disabled style={{ color: "#000" }}>
                  Please Select Shipping Carrier
                </MenuItem>
                {shippingCarrier.length != 0 &&
                  shippingCarrier.map((res) => (
                    <MenuItem
                      value={res.shipping_carrier_id}
                      style={{ color: "#000" }}
                      onClick={() => handleChangeShippingCarrier(res)}
                    >
                      {res.shippingcarrier}
                    </MenuItem>
                  ))}
              </FormInput>

              <FormInput
                label="Shipping Fee"
                value={orderFee.shipping_fee}
                textcolor="#707070"
                placeholder="Shipping Fee"
                name="shippingFee"
                bg="#fff"
                border="1px solid #c5c5c5"
                // type="number"
                onKeyPress={(event) => {
                  if (event.target.value == "" && !/[1-9]/.test(event.key)) {
                    event.preventDefault();
                  }
                }}
                step="0.01"
                inputProps={{ min: 0 }}
                onChange={(e) => {
                  // console.log(e.target.value, orderFee.shipping_fee)
                  setOrderFee({
                    ...orderFee,
                    shipping_fee: e.target.value,
                    shipping_fee_custom: true,
                  });
                  clearTimeout(is_changing_shipping_fee.current);
                }}
              />

              <Paragraph margin=".4rem 0">Customer Po Form</Paragraph>

              <div
                {...customerpoDropzone.getRootProps({
                  className: "dropzone",
                })}
                style={dropzone}
              >
                <input {...customerpoDropzone.getInputProps()} />
                <p>Drag 'n' drop some files here, or click to select files</p>
              </div>
              <>
                {files3 == [] ? (
                  <div {...customerpoDropzone.getRootProps({})}>
                    <input
                      {...customerpoDropzone.getInputProps()}
                      name="customerpo"
                    />
                  </div>
                ) : (
                  <>
                    <div>{thumbs3}</div>
                    {/* {fileRejectionItems} */}
                  </>
                )}
              </>
            </Grid>
            <Grid item xs={12} sm={12} md={6}>
              <Autocomplete
                id="customer_address_id"
                value={selectedShippingCustomerAddress}
                disabled={customerAddress.length == 0 ? true : false}
                // name="address_book_id"
                options={customerAddress}
                getOptionLabel={(option) =>
                  option.addr1 +
                  ", " +
                  option.addr2 +
                  " " +
                  option.city +
                  " " +
                  option.zip +
                  ", " +
                  option.state +
                  ", " +
                  option.country
                }
                onChange={(e, value) => {
                  // console.log('value', value)
                  if (value != null) {
                    setSelectedShippingCustomerAddress({
                      ...selectedShippingCustomerAddress,
                      customer_address_id: value.customer_address_id,
                      addr1: value.addr1,
                      addr2: value.addr2,
                      city: value.city,
                      zip: value.zip,
                      state: value.state,
                      country: value.country,
                    });
                  } else {
                    setSelectedShippingCustomerAddress({
                      ...selectedShippingCustomerAddress,
                      customer_address_id: "",
                      addr1: "",
                      addr2: "",
                      city: "",
                      zip: "",
                      state: "",
                      country: "",
                    });
                  }
                }}
                style={{ width: "100%" }}
                renderInput={(params) => (
                  <FormInput
                    {...params}
                    label="Shipping Address*"
                    // value={addressData.addr1}
                    textLabelColor="#000"
                    placeholder={
                      customerAddress.length == 0
                        ? "Please Choose Customer"
                        : "Please Choose Shipping Address"
                    }
                    name="customer_address_id"
                    border="1px solid #c5c5c5"
                    padding="0.6rem 4rem 0.6rem 1rem"
                    bg={customerAddress.length == 0 ? "#c5c5c5" : "#fff"}
                    inputProps={{
                      ...params.inputProps,
                      autoComplete: "new-password",
                    }}
                    // placeholder='Select Address'
                  />
                )}
              />
              <FormInput
                label="Deposit"
                value={deposit}
                textcolor="#707070"
                placeholder="Deposit"
                name="deposit"
                bg="#fff"
                border="1px solid #c5c5c5"
                // type="number"

                onKeyPress={(event) => {
                  if (event.target.value == "" && !/[1-9]/.test(event.key)) {
                    event.preventDefault();
                  }
                }}
                inputProps={{ min: 0 }}
                onKeyDown={(e) =>
                  e.key === "Enter" &&
                  setDeposit(parseFloat(deposit).toFixed(2))
                }
                onBlur={() => setDeposit(parseFloat(deposit).toFixed(2))}
                onChange={(e) => setDeposit(e.target.value)}
              />
              <FormInput
                label="Sales Remark"
                value={remark.sales_remark}
                textcolor="#707070"
                placeholder="Sales Remark"
                r
                name="sales_remark"
                bg="#fff"
                border="1px solid #c5c5c5"
                onChange={handleChangeRemark}
              />
              <FormInput
                label="Customer Remark"
                value={remark.customer_remark}
                textcolor="#707070"
                placeholder="Customer Remark"
                name="customer_remark"
                bg="#fff"
                border="1px solid #c5c5c5"
                onChange={handleChangeRemark}
              />
              <FormInput
                label="Memo"
                value={remark.memo}
                textcolor="#707070"
                placeholder="Memo"
                name="memo"
                bg="#fff"
                border="1px solid #c5c5c5"
                onChange={handleChangeRemark}
              />
              {selectedCustomer !== null &&
                selectedCustomer.paymenttype == "Credit" && (
                  <React.Fragment>
                    <Paragraph margin=".4rem 0">Bypass Credit Limit</Paragraph>
                    <Checkbox
                      onChange={() =>
                        setRemark({
                          ...remark,
                          bypasscl: !remark.bypasscl,
                        })
                      }
                      checked={remark.bypasscl}
                      sx={{
                        padding: "0 .4rem 0 0",
                        color: "#1A5386 ",
                        "&.Mui-checked": {
                          color: "#1A5386 ",
                        },
                      }}
                    />
                    {remark.bypasscl ? "Yes" : "No"}
                  </React.Fragment>
                )}

              <Paragraph margin=".4rem 0">Attachment</Paragraph>

              <div
                {...attachmentDropzone.getRootProps({
                  className: "dropzone",
                })}
                style={dropzone}
              >
                <input {...attachmentDropzone.getInputProps()} />
                <p>Drag 'n' drop some files here, or click to select files</p>
              </div>
              <>
                {files2 == [] ? (
                  <div {...attachmentDropzone.getRootProps({})}>
                    <input
                      {...attachmentDropzone.getInputProps()}
                      name="attachment"
                    />
                  </div>
                ) : (
                  <>
                    <div>{thumbs2}</div>
                  </>
                )}
              </>
              <Paragraph margin=".4rem 0">Upload Consignment Note</Paragraph>
              <div
                {...getRootProps({ className: "dropzone" })}
                style={dropzone}
              >
                <input {...getInputProps()} />
                <p>Drag 'n' drop some files here, or click to select files</p>
              </div>
              <>
                {files == [] ? (
                  <div {...getRootProps({})}>
                    <input {...getInputProps()} />
                  </div>
                ) : (
                  <>
                    <div>{thumbs}</div>
                  </>
                )}
              </>
            </Grid>
          </Grid>

          <Button
            onClick={() => handleDirectCheckout()}
            label="Order Now"
            color="#fff"
            bg="#1A5386"
            size="18px"
            pd="10px"
            br="5px"
            style={{ marginBottom: "10px" }}
          />
        </DialogContent>
      </Dialog>
    </React.Fragment>
  );
}
